import _extends from "@babel/runtime/helpers/extends";
import { forwardRef, useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { EditorView } from '@codemirror/view';
import { jsx as _jsx } from "react/jsx-runtime";
var defalutTheme = document.documentElement.getAttribute('data-color-mode');
export var CodeEditor = /*#__PURE__*/forwardRef((props, ref) => {
  var borderRadius = EditorView.theme({
    '.cm-scroller, &': {
      borderRadius: '6px'
    },
    '&': {
      border: '1px solid var(--color-border-default)'
    }
  });
  var _props$extensions = props.extensions,
    extensions = _props$extensions === void 0 ? [] : _props$extensions,
    _props$theme = props.theme,
    pTheme = _props$theme === void 0 ? 'dark' : _props$theme;
  var _useState = useState(pTheme || defalutTheme),
    theme = _useState[0],
    setTheme = _useState[1];
  useEffect(() => {
    var val = document.documentElement.getAttribute('data-color-mode');
    setTheme(val);
    document.addEventListener('colorschemechange', e => {
      setTheme(e.detail.colorScheme);
    });
  }, []);
  return /*#__PURE__*/_jsx(CodeMirror, _extends({
    ref: ref
  }, props, {
    style: {
      padding: 1
    },
    extensions: [borderRadius, ...extensions],
    theme: theme
  }));
});